"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Legaldisclaimer() {
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="4199" id="legaldisclaimer" className="bg-background text-foreground py-20 md:py-28 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div ref={cardRef} className={`relative bg-card rounded-lg overflow-hidden shadow-2xl transition-all duration-1000 ease-out ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="absolute -top-32 -left-32 w-96 h-96 rounded-lg bg-accent/10 blur-3xl pointer-events-none" aria-hidden="true" />
          <div className="absolute -bottom-40 right-1/3 w-[28rem] h-[28rem] rounded-lg bg-accent/5 blur-3xl pointer-events-none" aria-hidden="true" />

          <div className="relative grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-8 p-8 sm:p-12 lg:p-20">
            {}
            <div className="lg:col-span-3 flex flex-col justify-center order-2 lg:order-1">
              <span className="font-default text-xs sm:text-sm uppercase tracking-widest text-accent mb-6">
                Hukuki Bilgilendirme ve Sorumluluk
              </span>

              <h2 className="font-default text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] text-card-foreground mb-8">
                Yasal
                <br />
                <span className="italic text-accent">sorumluluk</span>
                <br />
                beyanımız.
              </h2>

              <p className="font-default text-base sm:text-lg leading-relaxed text-muted-foreground mb-10 max-w-xl">
                Bu web sitesinde yer alan tüm içerikler yalnızca bilgilendirme amaçlıdır. Sunulan makaleler ve görüşler, profesyonel bir hukuki mütalaa veya danışmanlık yerine geçmez. Her somut olay kendi özelinde değerlendirilmelidir.
              </p>

              <div className="flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8">
                <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 rounded-lg px-8 py-6 text-base font-medium shadow-md transition-all">
                  <Link to="/ContactPage">Danışmanlık Alın</Link>
                </Button>

                <Link to="/ArticlesPage" className="inline-flex items-center gap-2 text-foreground hover:text-accent transition-colors font-default text-base group">
                  <span className="border-b border-accent/40 pb-1">
                    Makaleleri İncele
                  </span>
                  <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </div>
            </div>

            {}
            <div className="lg:col-span-2 flex items-center justify-center order-1 lg:order-2">
              <div ref={imageRef} className={`relative w-full max-w-sm lg:max-w-none aspect-square lg:translate-x-8 xl:translate-x-16 transition-all duration-1000 delay-200 ease-out ${imageVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}>
                <div className="absolute inset-0 rounded-lg overflow-hidden shadow-2xl ring-1 ring-border">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695387/img/legal_disclaimer_office.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695387/img/legal_disclaimer_office.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695387/img/legal_disclaimer_office.png-wvc-sizes" alt="Modern hukuk ofisi ve adalet terazisi detayı" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
                </div>
                {}
                <div className="absolute -inset-3 rounded-lg border border-accent/20 pointer-events-none" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}